export default "__VITE_ASSET__341751c0__"